import { render, staticRenderFns } from "./spaceFile.vue?vue&type=template&id=63d31d64&scoped=true"
import script from "./spaceFile.vue?vue&type=script&lang=js"
export * from "./spaceFile.vue?vue&type=script&lang=js"
import style0 from "./spaceFile.vue?vue&type=style&index=0&id=63d31d64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d31d64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d31d64')) {
      api.createRecord('63d31d64', component.options)
    } else {
      api.reload('63d31d64', component.options)
    }
    module.hot.accept("./spaceFile.vue?vue&type=template&id=63d31d64&scoped=true", function () {
      api.rerender('63d31d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/layout/spaceFile.vue"
export default component.exports